import {
  ActivityItem,
  AdminAccount,
  AdvertisementItem,
  BoardMember,
  CultureItem,
  DocumentItem,
  DonationRecord,
  EventItem,
  EventTicket,
  HeroSlide,
  MediaGalleryItem,
  MemberUser,
  NewsItem,
  SiteSettings,
  UserTicketPurchase,
} from '../types';

export const initialSiteSettings: SiteSettings = {
  siteName: 'KOMELIYA ÇANDÎ YA FRANSÎ-KURDÎ YA YVELINES',
  siteUrl: 'https://franco-kurde-komuneyvelines.fr',
  subTitle: 'Soreş û çand, rûmeta me ye',
  logoText1: 'KOMELIYA ÇANDÎ YA',
  logoText2: 'FRANSÎ-KURDÎ YA YVELINES',
  logoText3: 'ASSOC. CULTURELLE FRANCO-KURDE',
  logoImageUrl: '/uploads/logo.png',
  address: '250 bis boulevard maréchal juin 78200 Mantes La Jolie',
  phone: '+33 6 14 62 97 06',
  whatsapp: '+33614629706',
  email: 'info@kurdernegi.org',
  paymentGateway: {
    activeProvider: 'sanal_pos',
    providerName: 'Dernek Resmi Sanal POS & SEPA IBAN Geçidi',
    testMode: false,
    merchantId: '30094812',
    apiKey: 'kkdd-pos-live-api-key-9921',
    secretKey: '30094812_SEC_KEY_2026',
    terminalId: 'TR-78200-POS',
    bankAccountName: 'Kürt Kültür ve Dayanışma Derneği Yvelines',
    iban: 'FR76 3000 4000 0123 4567 8901 234',
    swiftCode: 'AGRIFRPPXXX',
    autoDebitEnabled: true,
    minDonationAmount: 5,
    currency: 'EUR',
    redirect3dSecure: true,
    updatedAt: '2026-07-26',
  },
  donationCampaigns: [
    {
      id: 'camp-1',
      title: 'Dil Kursları ve Kültür Evi Destek Fonu',
      category: 'Eğitim & Dil',
      description: 'Derneğimizde verilen Kürtçe dil dersleri, öğretmen maaşları, ders materyalleri ve kültür evi kira & işletme giderlerini karşılar.',
      targetAmount: 20000,
      collectedAmount: 14500,
      isActive: true,
    },
    {
      id: 'camp-2',
      title: 'Öğrenci Burs Fonu',
      category: 'Eğitim Yardım',
      description: 'Yurtdışında ve bölgede üniversite okuyan ihtiyaç sahibi 50+ öğrenciye her ay düzenli eğitim bursu desteği sağlar.',
      targetAmount: 15000,
      collectedAmount: 11200,
      isActive: true,
    },
    {
      id: 'camp-3',
      title: 'Newroz Festivali Kültür Sponsorluğu',
      category: 'Kültür & Etkinlik',
      description: 'Geleneksel Newroz kutlaması, sahne kurulumu, dengbêj ve sanatçı ağırlama, halk oyunları kostümleri ve organizasyon fonu.',
      targetAmount: 10000,
      collectedAmount: 8900,
      isActive: true,
    },
    {
      id: 'camp-4',
      title: 'İnsani Yardım ve Acil Afet Fonu',
      category: 'Acil Yardım',
      description: 'Doğal afetler, acil insani krizler ve dayanışma ihtiyacı duyan aileler için anında devredilen acil destek fonu.',
      targetAmount: 30000,
      collectedAmount: 19750,
      isActive: true,
    },
  ],
  social: {
    facebook: 'https://facebook.com/kurdernegi',
    instagram: 'https://instagram.com/kurdernegi',
    youtube: 'https://youtube.com/kurdernegi',
    linkedin: 'https://linkedin.com/company/kurdernegi',
    twitter: 'https://x.com/kurdernegi',
  },
  socialLinks: {
    facebook: 'https://facebook.com/kurdernegi',
    instagram: 'https://instagram.com/kurdernegi',
    youtube: 'https://youtube.com/kurdernegi',
    linkedin: 'https://linkedin.com/company/kurdernegi',
    twitter: 'https://x.com/kurdernegi',
  },
  liveStream: {
    isLive: true,
    title: 'Kürt Dil Haftası Özel Semineri & Dengbêj Dinletisi (CANLI YAYIN)',
    description: 'Kürt Kültür ve Dayanışma Derneği Ana Salonunda gerçekleşen canlı yayın semineri. Dengbêjlerimizin sesi ve dil atölyesi sunumu ile sizlerle buluşuyoruz.',
    platform: 'YouTube',
    youtubeUrl: 'https://www.youtube.com/live/yZ7eZ8H_a1I?is=jgy0RIN_u-bmXzg1',
    facebookUrl: 'https://facebook.com/kurdernegi/live',
    vimeoUrl: '',
    embedUrl: 'https://www.youtube.com/embed/yZ7eZ8H_a1I',
    coverImage: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=1200&q=80',
    viewerCount: 342,
    startDate: '2026-07-21',
    startTime: '20:00',
    endDate: '2026-07-21',
    endTime: '22:30',
    obsRtmpUrl: 'rtmp://live.youtube.com/live2',
    obsStreamKey: 'kkdd-live-2026-secret-key-98231',
    pastRecordings: [
      {
        id: 'rec-1',
        title: 'Newroz 2026 Özel Canlı Yayını & Konser Programı',
        date: '2026-03-21',
        duration: '2s 45dk',
        url: 'https://www.youtube.com/embed/5qap5aO4i9A',
        thumbnail: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=600&q=80',
        views: 12400,
      },
      {
        id: 'rec-2',
        title: 'Kürt Edebiyatı Sempozyumu & Yazar Söyleşileri',
        date: '2026-05-10',
        duration: '1s 30dk',
        url: 'https://www.youtube.com/embed/5qap5aO4i9A',
        thumbnail: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=600&q=80',
        views: 5800,
      },
      {
        id: 'rec-3',
        title: 'Kürt Folkloru Halay Atölyesi Canlı Yayını',
        date: '2026-06-04',
        duration: '1s 15dk',
        url: 'https://www.youtube.com/embed/5qap5aO4i9A',
        thumbnail: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?auto=format&fit=crop&w=600&q=80',
        views: 8900,
      },
    ],
  },
  stats: {
    totalMembers: 1245,
    totalActivities: 48,
    totalEvents: 12,
    totalDonationsEuro: 54350,
  },
  maintenanceMode: false,
};

export const initialHeroSlides: HeroSlide[] = [
  {
    id: 'slide-1',
    title: {
      KM: 'Birliğimiz Kültürümüzdür',
      FR: 'Notre Unité est Notre Culture',
      DE: 'Unsere Einheit ist Unsere Kultur',
      EN: 'Our Unity is Our Culture',
      TR: 'Birliğimiz Kültürümüzdür',
    },
    subtitle: {
      KM: 'Çanda Kurdî dijî, ji nifşên nû re derbas dibe û bi piştgiriyê xurt dibe.',
      FR: 'Transmettre la culture kurde aux nouvelles générations et renforcer la solidarité.',
      DE: 'Die kurdische Kultur an neue Generationen weitergeben und die Solidarität stärken.',
      EN: 'Passing down Kurdish culture to new generations and building stronger solidarity.',
      TR: 'Kürt kültürünü yaşatıyor, gelecek nesillere aktarıyor ve dayanışma ile daha güçlü yarınlar inşa ediyoruz.',
    },
    image: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=2000&q=80',
    primaryBtnText: {
      KM: 'Derneğimizi Keşfedin',
      FR: 'Découvrir Association',
      DE: 'Verein Entdecken',
      EN: 'Discover Association',
      TR: 'Derneğimizi Keşfedin',
    },
    primaryBtnTarget: 'about',
    secondaryBtnText: {
      KM: 'Bize Katılın',
      FR: 'Rejoignez-nous',
      DE: 'Mitmachen',
      EN: 'Join Us',
      TR: 'Bize Katılın',
    },
    secondaryBtnTarget: 'membership',
    isActive: true,
  },
  {
    id: 'slide-2',
    title: {
      KM: 'Kurmancî & Soranî Zimanê Me Ye',
      FR: 'Notre Langue est Notre Identité',
      DE: 'Unsere Sprache ist Unsere Identität',
      EN: 'Language is Our Identity',
      TR: 'Dilimiz Kimliğimizdir',
    },
    subtitle: {
      KM: 'Kursên zimanê Kurdî ji bo zarok û ciwanan bi serketî berdewam dikin.',
      FR: 'Des cours de langue kurde interactifs pour enfants, jeunes et adultes.',
      DE: 'Interaktive Kurdisch-Sprachkurse für Kinder, Jugendliche und Erwachsene.',
      EN: 'Interactive Kurdish language courses for children, youth, and adults.',
      TR: 'Çocuklarımız, gençlerimiz ve yetişkinler için ücretsiz Kürtçe dil kurslarımız haftalık düzenlenmektedir.',
    },
    image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=2000&q=80',
    primaryBtnText: {
      KM: 'Kursên Ziman',
      FR: 'Cours de Langue',
      DE: 'Sprachkurse',
      EN: 'Language Courses',
      TR: 'Dil Kurslarını İncele',
    },
    primaryBtnTarget: 'activities',
    secondaryBtnText: {
      KM: 'Bağış Yapın',
      FR: 'Faire un Don',
      DE: 'Spenden',
      EN: 'Support Us',
      TR: 'Bağış Yapın',
    },
    secondaryBtnTarget: 'donate',
    isActive: true,
  },
];

export const initialBoardMembers: BoardMember[] = [
  {
    id: 'board-1',
    name: 'Dr. Serhat Botan',
    role: 'Dernek Başkanı',
    bio: 'Kültürel araştırmacı ve tarihçi. 15 yıldır dernek çatısı altında toplumsal dayanışma projelerini yönetmektedir.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80',
    email: 'baskan@kurdernegi.org',
    phone: '+33 6 11 22 33 44',
  },
  {
    id: 'board-2',
    name: 'Berîvan Amed',
    role: 'Başkan Yardımcısı & Kadın Çalışmaları',
    bio: 'Sosyolog ve insan hakları aktivisti. Kadın dayanışma merkezlerinin ve kültürel atölyelerin koordinatörüdür.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=600&q=80',
    email: 'berivan@kurdernegi.org',
  },
  {
    id: 'board-3',
    name: 'Cîhan Dersim',
    role: 'Genel Sekreter',
    bio: 'Dilbilimci ve eğitimci. Kürtçe edebiyat ve dil kurslarının müfredat sorumlusudur.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=600&q=80',
    email: 'sekreter@kurdernegi.org',
  },
  {
    id: 'board-4',
    name: 'Roza Zaza',
    role: 'Mali İşler Sorumlusu',
    bio: 'Finans uzmanı ve muhasebeci. Dernek şeffaf bağış ve yardım bütçelerini yönetmektedir.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=600&q=80',
    email: 'mali@kurdernegi.org',
  },
];

export const initialActivities: ActivityItem[] = [
  {
    id: 'act-1',
    title: {
      KM: 'Kursên Zimanê Kurdî (Kurmancî & Soranî)',
      FR: 'Cours de Langue Kurde',
      DE: 'Kurdische Sprachkurse',
      EN: 'Kurdish Language Courses',
      TR: 'Kürtçe Dil Kursları (Kurmancî & Soranî)',
    },
    category: 'Eğitim',
    description: {
      KM: 'Ji bo hemû temeniyan kursên zimanê Kurdî yên belaş.',
      FR: 'Cours gratuits de langue kurde pour tous les niveaux.',
      DE: 'Kostenlose Kurdischkurse für alle Altersgruppen.',
      EN: 'Free Kurdish language classes for beginner to advanced levels.',
      TR: 'Çocuklar, gençler ve yetişkinler için seviye tespitli ücretsiz Kürtçe dil eğitimleri.',
    },
    content: {
      KM: 'Her hefte roja şemiyê û yekşemiyê dersên ziman li navenda komelê têne danîn. Mamosteyên me yên pispor alîkariya xwendekaran dikin.',
      FR: 'Nos cours se déroulent les samedis et dimanches. Des enseignants certifiés accompagnent les étudiants.',
      DE: 'Unsere Kurse finden samstags und sonntags statt. Qualifizierte Lehrkräfte begleiten die Teilnehmer.',
      EN: 'Classes take place on weekends. Experienced instructors teach reading, writing, and conversational Kurdish.',
      TR: 'Hafta sonları dernek binamızda ve online olarak düzenlenen kurslarımızda dilbilgisi, okuma, yazma ve konuşma pratikleri yapılmaktadır.',
    },
    date: '2026-03-15',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1000&q=80',
    participantsCount: 140,
    location: 'Paris Merkez Dernek Binası & Zoom Online',
    isActive: true,
  },
  {
    id: 'act-2',
    title: {
      KM: 'Atolyeya Muzîkê û Dengbêjiyê',
      FR: 'Atelier de Musique et Dengbêj',
      DE: 'Musik & Dengbêj Workshop',
      EN: 'Music & Traditional Dengbêj Workshop',
      TR: 'Geleneksel Müzik ve Dengbêj Atölyesi',
    },
    category: 'Kültürel',
    description: {
      KM: 'Fêrbûna tembûr, def û hunerên dengbêjiyê.',
      FR: 'Apprentissage du tembûr, du def et des traditions orales Dengbêj.',
      DE: 'Erlernen von Tembûr, Def und kurdischer Gesangstradition.',
      EN: 'Learn traditional Kurdish instruments including Saz/Tembûr, Def, and Dengbêj singing.',
      TR: 'Gençlerimize ve müzikseverlere bağlama (tembûr), def ritim dersleri ve dengbêjlik geleneği eğitimi verilmektedir.',
    },
    content: {
      KM: 'Hunerên çandî stûna nasnameya me ne. Di vê atolyeyê de xwendekar stranan fêr dibin.',
      FR: 'La musique traditionnelle forme le cœur de notre héritage culturel.',
      DE: 'Traditionelle Musik bildet das Herzstück unseres kulturellen Erbes.',
      EN: 'Traditional music forms the core of our cultural heritage. Join our weekly acoustic circles.',
      TR: 'Usta sanatçılarımız eşliğinde her hafta gerçekleşen atölyelerde Kürt halk müzikleri ve makamları çalışılmaktadır.',
    },
    date: '2026-04-10',
    image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=1000&q=80',
    participantsCount: 85,
    location: 'Kültür Salonu',
    isActive: true,
  },
  {
    id: 'act-3',
    title: {
      KM: 'Kampa Ciwanan û Werzişê',
      FR: 'Camp de Jeunesse et Sport',
      DE: 'Jugendcamp & Sport',
      EN: 'Youth Camp & Sports Festival',
      TR: 'Gençlik Kampı ve Doğa Sporları Etkinliği',
    },
    category: 'Gençlik',
    description: {
      KM: 'Kampa salane ya ciwanan ji bo xurtkirina têkiliyan.',
      FR: 'Camp annuel de jeunesse pour renforcer les liens sociaux.',
      DE: 'Jährliches Jugendcamp zur Stärkung des Gemeinschaftssinns.',
      EN: 'Annual youth retreat focusing on outdoor sports, cultural seminars, and networking.',
      TR: 'Gençlerimizin kaynaşması, doğa sporu yapması ve kültürel seminerlere katılması için yıllık gençlik kampı.',
    },
    content: {
      KM: 'Ciwan paşeroja me ne. Di vê kampê de werziş, govend û seminerên dîrokî têne çêkirin.',
      FR: 'Activités sportives, danses folklores et séminaires historiques pour les jeunes.',
      DE: 'Sportliche Aktivitäten, Folkloretänze und historische Seminare für Jugendliche.',
      EN: 'Sports activities, folklore dancing, and history seminars specifically tailored for young members.',
      TR: 'Üç günlük kamp programında doğa yürüyüşleri, govend (halay) eğitimi, voleybol turnuvası ve söyleşiler yer alır.',
    },
    date: '2026-05-20',
    image: 'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&w=1000&q=80',
    participantsCount: 210,
    location: 'Ardennes Doğa Parkı',
    isActive: true,
  },
];

export const initialNews: NewsItem[] = [
  {
    id: 'news-1',
    title: {
      KM: 'Pîrozbahiya Newrozê bi Beşdariya Hezarî Hat Çêkirin',
      FR: 'Célébration du Newroz Réussie avec Plus de 1000 Participants',
      DE: 'Große Newroz-Feier mit über 1.000 Besuchern Erfolgreich Gefeiert',
      EN: 'Grand Newroz Festival Celebrated with Over 1,000 Guests',
      TR: 'Coşkulu Newroz Kutlaması Binlerce Kişinin Katılımıyla Gerçekleşti',
    },
    category: 'Dernek Haberleri',
    summary: {
      KM: 'Pîrozbahiya Newrozê ya salane bi şahiyên muzîk û govendê hat pîrozkirin.',
      FR: 'Le festival annuel du Newroz a réuni des familles autour de concerts et de danses traditionnelles.',
      DE: 'Das jährliche Newroz-Fest brachte Familien mit Konzerten und Tänzen zusammen.',
      EN: 'The annual Newroz festival brought families together for music concerts and folk dances.',
      TR: 'Derneğimizin düzenlediği yıllık Newroz etkinliğinde geleneksel govend gösterileri ve konserler büyük ilgi gördü.',
    },
    content: {
      KM: 'Agirê Newrozê hat hilkirin û hunermendên navdar hatin ser sehneyê. Serokê derneka me di axaftina xwe de bal kişand ser yekîtî û çandê.',
      FR: 'Le feu du Newroz a été allumé et des artistes renommés se sont produits sur scène.',
      DE: 'Das Newroz-Feuer wurde entzündet und renommierte Künstler traten auf der Bühne auf.',
      EN: 'The Newroz fire was lit and renowned musicians performed live. Association leaders highlighted the importance of cultural preservation.',
      TR: 'Geleneksel Newroz ateşi yakıldıktan sonra davul zurna eşliğinde halaylar çekildi. Dernek başkanımız konuşmasında dayanışma vurgusu yaptı.',
    },
    date: '2026-03-21',
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1000&q=80',
    author: 'Dernek Basın Burosu',
    tags: ['Newroz', 'Kültür', 'Konser', 'Dayanışma'],
    isFeatured: true,
    isActive: true,
  },
  {
    id: 'news-2',
    title: {
      KM: 'Rapora Alîkariya Zivistanê Hat Weşandin',
      FR: 'Publication du Rapport de Solidarité Hivernale',
      DE: 'Winterhilfe-Bericht Veröffentlicht',
      EN: 'Winter Relief Campaign Impact Report Published',
      TR: 'Kış Dayanışma Yardımları Raporu Yayınlandı',
    },
    category: 'Basın Açıklamaları',
    summary: {
      KM: 'Di çarçoveya kampanyaya zivistanê de alîkarî gihîşt 350 malbatan.',
      FR: 'Grâce à vos dons, 350 familles ont reçu des colis alimentaires et du matériel de chauffage.',
      DE: 'Dank Ihrer Spenden erhielten 350 Familien Lebensmittelpakete und Heizmittel.',
      EN: 'Thanks to donor support, winter packages were delivered to 350 families in need.',
      TR: 'Derneğimiz bağışçılarının desteğiyle ihtiyaç sahibi 350 aileye erzak ve ısınma yardımı ulaştırıldı.',
    },
    content: {
      KM: 'Spas ji bo hemû xêrxwazan. Komela me bi şffafî hemû alîkariyan gihand cihên pêwîst.',
      FR: 'Nous remercions chaleureusement tous les donateurs pour leur confiance et leur générosité.',
      DE: 'Wir danken allen Spendern herzlich für ihr Vertrauen und ihre Großzügigkeit.',
      EN: 'We express our deepest gratitude to all donors. Detailed receipts and financial breakdowns are available in our documents center.',
      TR: 'Şeffaflık ilkemiz gereği tüm yardım harcamaları bağımsız denetimden geçmiş olup detaylı finansal döküm belgelerimiz arasına eklenmiştir.',
    },
    date: '2026-02-10',
    image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1000&q=80',
    author: 'Yardım Komisyonu',
    tags: ['Dayanışma', 'Yardım', 'Rapor'],
    isFeatured: false,
    isActive: true,
  },
];

export const initialEvents: EventItem[] = [
  {
    id: 'evt-1',
    title: {
      KM: 'Şeva Çanda Kurdî & Konsera Dengbêjan',
      FR: 'Nuit de la Culture Kurde & Concert Dengbêj',
      DE: 'Kurdische Kulturnacht & Dengbêj-Konzert',
      EN: 'Kurdish Cultural Night & Dengbêj Concert',
      TR: 'Kürt Kültür Gecesi & Dengbêj Dinletisi',
    },
    date: '2026-08-15',
    time: '19:00',
    location: 'Paris Kültür Merkezi - Büyük Salon',
    address: '15 Boulevard de la Villette, 75010 Paris',
    coordinates: { lat: 48.8738, lng: 2.3681 },
    description: {
      KM: 'Konsera taybet a dengbêjên navdar û nimandina cil û bergên gelerî.',
      FR: 'Concert exceptionnel avec des maîtres Dengbêj et un défilé de tenues traditionnelles.',
      DE: 'Exklusives Konzert mit renommierten Dengbêj-Sängern und traditioneller Modenschau.',
      EN: 'An unforgettable evening of epic storytelling songs, traditional attires, and folk performances.',
      TR: 'Geleneksel dengbêjlerimizin sözlü destanları, otantik kıyafet defilesi ve ikramlar eşliğinde unutulmaz bir gece.',
    },
    image: 'https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1000&q=80',
    category: 'Konser',
    registeredCount: 310,
    maxCapacity: 450,
    isActive: true,
  },
  {
    id: 'evt-2',
    title: {
      KM: 'Seminera Edebiyat û Helbesta Kurdî',
      FR: 'Séminaire sur la Poésie et Littérature Kurde',
      DE: 'Seminar für Kurdische Poesie & Literatur',
      EN: 'Kurdish Poetry & Literature Symposium',
      TR: 'Kürt Edebiyatı ve Şiir Söyleşisi',
    },
    date: '2026-09-02',
    time: '16:00',
    location: 'Dernek Konferans Salonu',
    address: '123 Rue de la Paix, 75001 Paris',
    coordinates: { lat: 48.8686, lng: 2.3312 },
    description: {
      KM: 'Nîqaşa li ser helbestên Cegerxwîn, Feqiyê Teyran û Ehmedê Xanî.',
      FR: 'Conférence dédiée aux poètes classiques tels que Cegerxwîn et Ehmedê Xanî.',
      DE: 'Vortrag über klassische kurdische Dichter wie Cegerxwîn und Ehmedê Xanî.',
      EN: 'Literary discussions focusing on classic poets Cegerxwîn, Feqiyê Teyran, and Ehmedê Xanî.',
      TR: 'Klasik Kürt edebiyatının öncülerinin eserlerinin analizi ve canlı şiir dinletisi.',
    },
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=1000&q=80',
    category: 'Söyleşi',
    registeredCount: 88,
    maxCapacity: 120,
    isActive: true,
  },
];

export const initialCultureItems: CultureItem[] = [
  {
    id: 'cult-1',
    category: 'Müzik',
    title: {
      KM: 'Hunerê Dengbêjiyê (Hozanî)',
      FR: 'L\'Art du Dengbêj',
      DE: 'Die Kunst des Dengbêj',
      EN: 'The Dengbêj Oral Tradition',
      TR: 'Dengbêjlik Geleneği',
    },
    subtitle: {
      KM: 'Bîra dîrokî ya gelê Kurd di stranan de.',
      FR: 'La mémoire historique du peuple kurde par le chant oral.',
      DE: 'Das historische Gedächtnis des kurdischen Volkes in Liedern.',
      EN: 'The living historical archive of Kurdish history through oral epic songs.',
      TR: 'Kürt tarihinin, sevdalarının ve destanlarının enstrümansız veya sade saz eşliğinde kuşaktan kuşağa aktarıldığı sözlü hafıza.',
    },
    description: {
      KM: 'Dengbêj mirovên ku çîrok û dîroka kurdî bi stranan vedibêjin in.',
      FR: 'Le Dengbêj est le gardien de l\'histoire orale kurde.',
      DE: 'Dengbêj sind die Bewahrer der mündlichen Geschichte der Kurden.',
      EN: 'Dengbêjs are traditional bards who recite history, love stories, and epics strictly from memory.',
      TR: 'Dengbêjlik, yazılı kaynakların kısıtlı olduğu dönemlerde tarihi olayları, kahramanlıkları ve aşkları canlı tutan en köklü sanat biçimidir.',
    },
    content: {
      KM: 'Lawik, kilam, strranên şer û evînê parçeyên vê hunerê ne. Tembûr û def amûrên sereke ne.',
      FR: 'Les complaintes (Lawik), chants d\'amour et récits de bravoure constituent ce patrimoine inestimable.',
      DE: 'Epen, Klagelieder (Lawik) und Liebeslieder gehören zu dieser einzigartigen Kunstform.',
      EN: 'Key genres include Lawik (heroic/lament chants), Heyran, and Delal. Instruments commonly played alongside include the Tembûr (long-neck lute) and Def (frame drum).',
      TR: 'Klam, kilam û lawik kategorilerine ayrılan dengbêj kılamlarında insan doğası, göçler ve kahramanlık anlatılır.',
    },
    image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=1000&q=80',
    audioUrl: 'https://actions.google.com/sounds/v1/ambiences/outdoor_park.ogg',
  },
  {
    id: 'cult-2',
    category: 'Dil',
    title: {
      KM: 'Bikaranîna Zimanê Kurdî di Jiyana Rojane de',
      FR: 'La Langue Kurde au Quotidien',
      DE: 'Kurdische Sprache im Alltag',
      EN: 'Basic Kurdish Everyday Phrases',
      TR: 'Günlük Yaşamda Kürtçe İfadeler',
    },
    subtitle: {
      KM: 'Peyvên sereke yên Kurmancî bi deng û bilêvkirinê.',
      FR: 'Mots et expressions essentiels avec guide de prononciation audio.',
      DE: 'Wichtige Ausdrücke mit Audio-Aussprachehilfe.',
      EN: 'Essential Kurdish (Kurmancî) phrases with audio pronunciation guides.',
      TR: 'Görsel ve sesli telaffuz rehberi ile günlük hayatta sık kullanılan Kürtçe kelimeler.',
    },
    description: {
      KM: 'Rojbaş (Günaydın), Spas (Teşekkürler), Çawa yî? (Nasılsın?).',
      FR: 'Apprenez les salutations de base en kurmancî.',
      DE: 'Lernen Sie die wichtigsten Begrüßungen auf Kurmancî.',
      EN: 'Learn essential greetings and courteous expressions.',
      TR: 'Selamlaşma, teşekkür ve hal hatır sorma sözcükleri.',
    },
    content: {
      KM: '1. Rojbaş = Günaydın / Îro rojeke xweş e.\n2. Spas dikim = Teşekkür ederim.\n3. Tu çawa yî? = Nasılsın?\n4. Ez baş im = İyiyim.\n5. Bi xêr hatî = Hoş geldin.',
      FR: '1. Rojbaş = Bonjour\n2. Spas dikim = Merci\n3. Tu çawa yî? = Comment vas-tu?\n4. Ez baş im = Je vais bien.',
      DE: '1. Rojbaş = Guten Tag\n2. Spas dikim = Danke\n3. Tu çawa yî? = Wie geht es dir?\n4. Ez baş im = Mir geht es gut.',
      EN: '1. Rojbaş = Good morning / Good day\n2. Spas dikim = Thank you\n3. Tu çawa yî? = How are you?\n4. Ez baş im = I am well\n5. Bi xêr hatî = Welcome',
      TR: '1. Rojbaş = Günaydın / İyi günler\n2. Spas dikim = Teşekkür ederim\n3. Tu çawa yî? = Nasılsın?\n4. Ez baş im = İyiyim\n5. Bi xêr hatî = Hoş geldin',
    },
    image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&w=1000&q=80',
    pronunciation: 'Roj-bash | Spas di-kim | Tu cha-wa yi',
  },
  {
    id: 'cult-3',
    category: 'Kıyafetler',
    title: {
      KM: 'Cil û Bergên Gelerî yên Kurdî',
      FR: 'Costumes Traditionnels Kurdes',
      DE: 'Traditionelle Kurdische Trachten',
      EN: 'Traditional Kurdish Attire & Textiles',
      TR: 'Geleneksel Kürt Giysileri (Kras û Feqîyane)',
    },
    subtitle: {
      KM: 'Reng û motîfên ku çand û siruştê nîşan didin.',
      FR: 'Des couleurs éclatantes et des motifs inspirés par la nature.',
      DE: 'Lebendige Farben und von der Natur inspirierte Muster.',
      EN: 'Vibrant colors and intricate embroidery representing nature and regional heritage.',
      TR: 'Rengarenk kumaşlar, altın/gümüş işlemeli kemerler ve doğanın canlı tonlarını taşıyan geleneksel giysiler.',
    },
    description: {
      KM: 'Kras û feqîyane ji bo jinan, şal û şepek ji bo mêran.',
      FR: 'Kras û feqîyane pour les femmes, Şal û şepek pour les hommes.',
      DE: 'Trachten für Damen und Herren mit traditionellen Gürteln und Kopfbedeckungen.',
      EN: 'Women wear elegant long dresses with flowing sleeves (Feqîyane), while men wear suits known as Şal û Şepek with hand-woven belts.',
      TR: 'Kadınlarda dökümlü ve uzun kollu Kras û Feqîyane divaları, erkeklerde ise kuşaklı Şal û Şepek kıyafetleri öne çıkar.',
    },
    content: {
      KM: 'Ev cil di cejna Newrozê û govendan de têne gihiştin.',
      FR: 'Portés fièrement lors des fêtes du Newroz et des grands rassemblements.',
      DE: 'Getragen während des Newroz-Festes und traditioneller Tänze.',
      EN: 'Worn proudly during Newroz celebrations, weddings, and folk dance performances.',
      TR: 'Newroz festivalinde, düğünlerde ve kültür gecelerinde gururla giyilen bu giysiler bölge bölge özgün motifler barındırır.',
    },
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=1000&q=80',
  },
];

export const initialGallery: MediaGalleryItem[] = [
  {
    id: 'gal-1',
    type: 'photo',
    title: {
      KM: 'Pîrozbahiya Newrozê',
      FR: 'Festival de Newroz',
      DE: 'Newroz Feier',
      EN: 'Newroz Festival',
      TR: 'Newroz Kutlamaları',
    },
    url: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1200&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=500&q=80',
    category: 'Etkinlikler',
    date: '2026-03-21',
  },
  {
    id: 'gal-2',
    type: 'photo',
    title: {
      KM: 'Kursa Zimanê Kurdî',
      FR: 'Cours de Kurde',
      DE: 'Kurdischunterricht',
      EN: 'Kurdish Class',
      TR: 'Kürtçe Dersi Öğrencileri',
    },
    url: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80',
    thumbnail: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=500&q=80',
    category: 'Eğitim',
    date: '2026-02-18',
  },
  {
    id: 'gal-3',
    type: 'video',
    title: {
      KM: 'Dengbêj Dinletisi - Belgesel Video',
      FR: 'Concert Dengbêj - Vidéo',
      DE: 'Dengbêj Aufführung - Video',
      EN: 'Dengbêj Concert Performance Video',
      TR: 'Dengbêjlik Belgesel & Canlı Performans',
    },
    url: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&w=500&q=80',
    category: 'Kültür',
    date: '2026-01-25',
  },
];

export const initialDocuments: DocumentItem[] = [
  {
    id: 'doc-1',
    title: {
      KM: 'Tüzüğümüz û Rêziknameya Komelê',
      FR: 'Statuts Officiels de l\'Association',
      DE: 'Vereinssatzung',
      EN: 'Official Association Bylaws',
      TR: 'Dernek Tüzüğü ve Resmi Çalışma Yönetmeliği',
    },
    category: 'Tüzük',
    fileSize: '2.4 MB PDF',
    date: '2026-01-01',
    downloadCount: 420,
    fileUrl: '#',
  },
  {
    id: 'doc-2',
    title: {
      KM: 'Rapora Faaliyetan a Salane 2025',
      FR: 'Rapport d\'Activité Annuel 2025',
      DE: 'Jahresbericht 2025',
      EN: '2025 Annual Activity & Financial Report',
      TR: '2025 Yılı Faaliyet ve Mali Şeffaflık Raporu',
    },
    category: 'Faaliyet Raporu',
    fileSize: '4.8 MB PDF',
    date: '2026-01-15',
    downloadCount: 310,
    fileUrl: '#',
  },
  {
    id: 'doc-3',
    title: {
      KM: 'Forma Serlêdana Endametiya Nû',
      FR: 'Formulaire d\'Adhésion Papier',
      DE: 'Mitgliedsantrag Formular',
      EN: 'Membership Application Form (Printable)',
      TR: 'Yazılı Üyelik Başvuru Formu ve Beyanname',
    },
    category: 'Formlar',
    fileSize: '1.1 MB PDF',
    date: '2026-02-01',
    downloadCount: 650,
    fileUrl: '#',
  },
];

export const initialMembers: MemberUser[] = [
  {
    id: 'user-demo',
    memberNo: 'KKDD-2024-0042',
    fullName: 'Deniz Yılmaz',
    email: 'deniz@example.com',
    phone: '+33 6 99 88 77 66',
    role: 'member',
    status: 'active',
    joinDate: '2024-02-12',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=300&q=80',
    address: '42 Rue Saint-Denis',
    city: 'Paris',
    country: 'France',
    duesStatus: 'up_to_date',
    totalDonations: 350,
  },
  {
    id: 'admin-demo',
    memberNo: 'KKDD-2024-0001',
    fullName: 'Dr. Serhat Botan',
    email: 'baskan@kurdernegi.org',
    phone: '+33 6 11 22 33 44',
    role: 'admin',
    status: 'active',
    joinDate: '2023-01-01',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80',
    address: '123 Rue de la Paix',
    city: 'Paris',
    country: 'France',
    duesStatus: 'up_to_date',
    totalDonations: 1200,
  },
  {
    id: 'member-3',
    memberNo: 'KKDD-2024-0089',
    fullName: 'Zerya Dersim',
    email: 'zerya.dersim@example.com',
    phone: '+33 6 12 34 56 78',
    role: 'member',
    status: 'active',
    joinDate: '2024-05-18',
    avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=300&q=80',
    address: '15 Avenue de Versailles',
    city: 'Paris',
    country: 'France',
    duesStatus: 'overdue',
    totalDonations: 0,
  },
  {
    id: 'member-4',
    memberNo: 'KKDD-2025-0112',
    fullName: 'Amed Yılmaz',
    email: 'amed.yilmaz@example.org',
    phone: '+33 6 55 44 33 22',
    role: 'member',
    status: 'active',
    joinDate: '2025-01-10',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=300&q=80',
    address: '8 Boulevard Juin',
    city: 'Mantes-la-Jolie',
    country: 'France',
    duesStatus: 'overdue',
    totalDonations: 50,
  },
  {
    id: 'member-5',
    memberNo: 'KKDD-2024-0019',
    fullName: 'Berfin Baran',
    email: 'berfin.b@example.com',
    phone: '+33 6 77 88 99 00',
    role: 'board',
    status: 'active',
    joinDate: '2024-01-15',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=300&q=80',
    address: '22 Rue Victor Hugo',
    city: 'Versailles',
    country: 'France',
    duesStatus: 'up_to_date',
    totalDonations: 420,
  },
  {
    id: 'member-6',
    memberNo: 'KKDD-2025-0205',
    fullName: 'Kawa Cizîrî',
    email: 'kawa.ciziri@example.org',
    phone: '+33 6 33 22 11 00',
    role: 'member',
    status: 'active',
    joinDate: '2025-03-22',
    avatar: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?auto=format&fit=crop&w=300&q=80',
    address: '70 Rue de Mantes',
    city: 'Poissy',
    country: 'France',
    duesStatus: 'overdue',
    totalDonations: 0,
  },
];

export const initialDonations: DonationRecord[] = [
  {
    id: 'don-1',
    donorName: 'Deniz Yılmaz',
    donorEmail: 'deniz@example.com',
    amount: 100,
    currency: 'EUR',
    campaign: 'Dil Kursları ve Kültür Evi Destek Fonu',
    date: '2026-06-12',
    paymentMethod: 'Sanal POS (Kredi Kartı)',
    receiptNo: 'RCP-2026-8812',
    verificationStatus: 'Approved',
    memberFullNameMatched: 'Deniz Yılmaz',
    cardHolderNameMatched: 'DENIZ YILMAZ',
    verificationNotes: 'Sunucu doğrulamasından %100 isim eşleşmesi ile geçti ve Yönetim Kurulu tarafından onaylandı.',
    verifiedAt: '2026-06-12T14:30:00Z',
    status: 'Completed',
  },
  {
    id: 'don-2',
    donorName: 'Dr. Serhat Botan',
    donorEmail: 'baskan@kurdernegi.org',
    amount: 500,
    currency: 'EUR',
    campaign: 'Newroz Festivali Kültür Sponsorluğu',
    date: '2026-07-28',
    paymentMethod: 'SEPA / IBAN Transferi',
    receiptNo: 'RCP-2026-7731',
    verificationStatus: 'Pending_Admin_Approval',
    memberFullNameMatched: 'Dr. Serhat Botan',
    verificationNotes: 'GÜVENLİ BAĞIŞ DOĞRULAMASI: Sunucu kimlik kontrolü yapıldı. Yönetim Kurulu finansal nihai onayı bekleniyor.',
    verifiedAt: '2026-07-28T10:15:00Z',
    status: 'Active',
  },
  {
    id: 'don-3',
    donorName: 'Berfin Baran',
    donorEmail: 'berfin.b@example.com',
    amount: 250,
    currency: 'EUR',
    campaign: 'Öğrenci Burs Fonu',
    date: '2026-07-29',
    paymentMethod: 'Sanal POS (Kredi Kartı)',
    receiptNo: 'RCP-2026-9041',
    verificationStatus: 'Pending_Admin_Approval',
    memberFullNameMatched: 'Berfin Baran',
    cardHolderNameMatched: 'BERFIN BARAN',
    verificationNotes: 'Sanal POS 3D Secure doğrulaması ve üye adı eşleşmesi başarılı. Yönetim kurulu incelemesinde.',
    verifiedAt: '2026-07-29T09:00:00Z',
    status: 'Active',
  },
];

export const initialAdminAccounts: AdminAccount[] = [
  {
    id: 'admin-1',
    fullName: 'Yönetim Kurulu Başkanı (Süper Admin)',
    email: 'admin@admin.fr',
    password: 'Bordeaux33fr',
    role: 'SuperAdmin',
    status: 'active',
    createdAt: '2026-01-01',
    lastLogin: '2026-07-24 10:00',
  },
  {
    id: 'admin-2',
    fullName: 'Kültür & Sanat Editörü',
    email: 'editor@kurdishculture.org',
    password: 'editor123',
    role: 'Editor',
    status: 'active',
    createdAt: '2026-02-15',
    lastLogin: '2026-07-21 18:30',
  },
];

export const initialAdvertisements: AdvertisementItem[] = [
  {
    id: 'ad-1',
    companyName: 'Mantes Döner & Grill Restoran',
    logo: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=200&q=80',
    image: 'https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=800&q=80',
    category: 'Restoran & Gıda',
    address: '250 Boulevard Maréchal Juin, 78200 Mantes-la-Jolie',
    phone: '+33 1 34 77 88 99',
    whatsapp: '+33 6 12 34 56 78',
    email: 'contact@mantesdoner.fr',
    website: 'https://mantesdoner.fr',
    contactPerson: 'Ahmet Usta',
    summary: 'Özel marinasyonlu yaprak döner, helal Izgara eşitleri, köfte ve taze pide fırını ile hizmetinizdeyiz.',
    content: 'Mantes-la-Jolie ve çevresindeki tüm hemşehri ve dostlarımıza en leziz helal et çeşitlerini sunuyoruz.',
    startDate: '2026-08-01',
    endDate: '2026-09-01',
    isActive: true,
    createdAt: '2026-08-01T10:00:00Z',
  },
  {
    id: 'ad-2',
    companyName: 'Bozan İnşaat & Mimarlık Paris',
    logo: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=200&q=80',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80',
    category: 'İnşaat & Mimarlık',
    address: '12 Rue de la République, 75011 Paris',
    phone: '+33 6 88 77 66 55',
    whatsapp: '+33 6 88 77 66 55',
    email: 'info@bozan-batiment.fr',
    website: 'https://bozan-batiment.fr',
    contactPerson: 'Mimar Hasan Bozan',
    summary: 'Ev ve iş yeri tadilatı, izolasyon, fayans, boya-badana ve anahtar teslim inşaat projeleri.',
    content: 'Île-de-France bölgesinde 15 yıllık tecrübemiz ve uzman ekibimizle hizmetinizdeyiz.',
    startDate: '2026-08-01',
    endDate: '2026-09-01',
    isActive: true,
    createdAt: '2026-08-01T12:00:00Z',
  },
];

export const initialEventTickets: EventTicket[] = [
  {
    id: 'ticket-1',
    eventName: 'Yvelines Büyük Newroz Gecesi & Konseri 2026',
    ticketTitle: 'VIP Protokol & Konser Bilet',
    address: 'Salle des Fêtes, 14 Rue de la Liberté, 78200 Mantes-la-Jolie',
    date: '2026-03-21',
    time: '18:00',
    price: 35,
    currency: '€',
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=800&q=80',
    description: 'Yvelines Kürt Derneği geleneksel Newroz festivali konser girişi. Dengbêjler, halk oyunları ekibi, akşam ikramları ve canlı orkestra dahil.',
    quota: 300,
    soldCount: 42,
    isActive: true,
    createdAt: '2026-08-01T10:00:00Z',
  },
  {
    id: 'ticket-2',
    eventName: 'Yvelines Büyük Newroz Gecesi & Konseri 2026',
    ticketTitle: 'Genel Giriş Bilet',
    address: 'Salle des Fêtes, 14 Rue de la Liberté, 78200 Mantes-la-Jolie',
    date: '2026-03-21',
    time: '18:00',
    price: 20,
    currency: '€',
    image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=800&q=80',
    description: 'Büyük salon katılımı ve sahne performansları için genel bilet.',
    quota: 500,
    soldCount: 120,
    isActive: true,
    createdAt: '2026-08-01T10:00:00Z',
  },
  {
    id: 'ticket-3',
    eventName: 'Kürt Dili ve Mezopotamya Kültür Paneli',
    ticketTitle: 'Kültür Konferans Katılım Bilet',
    address: 'Centre Culturel Mantes, 78200 Mantes-la-Jolie',
    date: '2026-09-15',
    time: '14:00',
    price: 15,
    currency: '€',
    image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=800&q=80',
    description: 'Akademisyenler ve yazarlar eşliğinde dil paneli, kitap imza günü ve çay-kahve büfesi kullanımı.',
    quota: 150,
    soldCount: 18,
    isActive: true,
    createdAt: '2026-08-02T12:00:00Z',
  },
];

export const initialUserTicketPurchases: UserTicketPurchase[] = [
  {
    id: 'TK-842109',
    ticketId: 'ticket-1',
    eventName: 'Yvelines Büyük Newroz Gecesi & Konseri 2026',
    ticketTitle: 'VIP Protokol & Konser Bilet',
    address: 'Salle des Fêtes, 14 Rue de la Liberté, 78200 Mantes-la-Jolie',
    date: '2026-03-21',
    time: '18:00',
    price: 35,
    currency: '€',
    userId: 'mem-101',
    userFullName: 'Cewad Karahan',
    userPhone: '+33 6 12 34 56 78',
    userEmail: 'cewad.karahan@gmail.com',
    paymentMethod: 'credit_card',
    paymentReference: 'PAY-CC-99421',
    status: 'approved',
    isUsed: false,
    qrCode: 'TK-842109:ticket-1',
    createdAt: '2026-08-03T14:20:00Z',
  },
  {
    id: 'TK-993102',
    ticketId: 'ticket-2',
    eventName: 'Yvelines Büyük Newroz Gecesi & Konseri 2026',
    ticketTitle: 'Genel Giriş Bilet',
    address: 'Salle des Fêtes, 14 Rue de la Liberté, 78200 Mantes-la-Jolie',
    date: '2026-03-21',
    time: '18:00',
    price: 20,
    currency: '€',
    userId: 'mem-102',
    userFullName: 'Ruken Yılmaz',
    userPhone: '+33 6 98 76 54 32',
    userEmail: 'ruken.yilmaz@gmail.com',
    paymentMethod: 'bank_transfer',
    paymentReference: 'HAVALE-REF-7712',
    status: 'pending',
    isUsed: false,
    qrCode: 'TK-993102:ticket-2',
    createdAt: '2026-08-04T09:10:00Z',
  },
];


